import {
  BaseSidebarContentProps,
  SidebarCategoryItemProps,
} from '@/contexts/SidebarContext/types';
import {Box} from '@mui/material';
import {SidebarCategoryItem} from './SidebarCategoryItem';

type SidebarContentProps = {
  items: SidebarCategoryItemProps[];
  isPinned: boolean;
} & BaseSidebarContentProps;

export const SidebarContent = (props: SidebarContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: props.isPinned ? 'stretch' : 'center',
        gap: '4px',
        width: '100%',
      }}
    >
      {props.items.map(item => (
        <SidebarCategoryItem
          key={item.label}
          icon={item.icon}
          label={item.label}
          url={item.url}
          isPinned={props.isPinned}
          BadgeComponent={item.BadgeComponent}
        />
      ))}
    </Box>
  );
};
